import React from 'react';
import { useCreditRequest } from '../../../hooks/useCreditRequest';
import DiscoveryRefused, { DiscoveryRefusedProps } from './DiscoveryRefused';

/** The Step 2 refusal with its "Request more credits" state attached; see `ConnectedCreditsPicker`. */
export const ConnectedDiscoveryRefused: React.FC<Omit<DiscoveryRefusedProps, 'creditRequest'>> = (props) => {
  const creditRequest = useCreditRequest();
  return <DiscoveryRefused {...props} creditRequest={creditRequest} />;
};

export default ConnectedDiscoveryRefused;
